export default class FeaturedCollections extends HTMLElement {
  connectedCallback() {
    // Get all elements with the class .description within the component
    const descriptions = this.querySelectorAll('.description');

    // Calculate the maximum height
    const maxHeight = Array.from(descriptions).reduce((max, elem) =>
      Math.max(max, elem.offsetHeight), 0);

    // Apply the maximum height to each .description element
    descriptions.forEach((elem) => {
      /* eslint-disable no-param-reassign */
      elem.style.height = `${maxHeight}px`;
    });
  }
}

export const webcomponent = 'featured-collections';
